// extracted by mini-css-extract-plugin
export default {"root":"V7yzt","llama":"_1XAey","big":"_1-3EP","small":"_2XJ1H"};